import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { Heading } from '@ff-os/shared-react/components/panel/Heading';
import { Panel } from '@ff-os/shared-react/components/panel/Panel';
import styles from './AddGroupButtonMobile.module.scss';

export const AddGroupButtonMobile = ({ onClick }: Props) => {
    const { t } = useTranslation();
    return (
        <Panel onClick={onClick}>
            <Heading className={styles.heading}>
                <Icon className={styles.icon} size='large' strokeWidth={2} type='alert-circle-plus' />
                {t('photo_prints.new_group')}
            </Heading>
        </Panel>
    );
};

type Props = {
    onClick: () => void;
};